import { getCsrfValue } from "~/common/utils/ApiHelper";
import { resolveApiUrl } from "~/utils/url/urlResolver";

export function sendData(wishlistId: string) {
  const apiUrl = resolveApiUrl(`/wishlist/delete?id=${wishlistId}`);

  return fetch(apiUrl, {
    method: "DELETE",
    cache: "no-cache",
    credentials: "same-origin", // include, omit
    mode: "cors", // no-cors, same-origin
    referrer: "no-referrer", // client
    headers: {
      "content-type": "application/json",
      CSRFToken: getCsrfValue(),
    },
  });
}
